export class ModifierDisplayPosition {
    public static STANDARD = 'STANDARD';
    public static LEFT = 'LEFT';
    public static RIGHT = 'RIGHT';
}
